import React from "react";
import {Grid} from "@material-ui/core";
import axios from "axios";
import {connect} from "react-redux";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import backgroundImage from "../../../assets/images/main_background.png";
import Wheel from "../../../assets/images/wheel.png";
import CoinBox from "../../../assets/images/ic_coins.png";
import Play from "../../../assets/images/ic_play.png";
import Toolbar from "../../Toolbar";
import ItemHolder from "../../pageComponents/Settings/Free/ItemHolder";
import PrizeCode from "../../pageComponents/Settings/Free/PrizeCode";
import Ad from "../../pageComponents/Settings/Free/Ad";
import Invitation from "../../pageComponents/Settings/Free/Invitation";
import Video from "../../pageComponents/Settings/Free/Video";
import {FREE} from "../../../Store/Actions/Types"
import {data} from "../../../Store/Actions/DataAction";
import {free} from "../../../Store/Actions/FreeAction";
import goldCoin from "../../../assets/images/ic_coin.png";
import silverCoin from "../../../assets/images/ic_silver_coin.png";
import telegram from "../../../assets/images/telegram.png";
import instagram from "../../../assets/images/instagram_logo.png";
import PicoLoader from "../../pageComponents/Common/PicoLoader";
import CustomDialog from "../../pageComponents/Common/Dialog";
import {rollList, userData} from "../../../Utility/Url";

class FreePage extends React.Component {
    constructor(props) {
        super(props)
        this.state= {
            showDialog:false,
            dialogDetail:null,
            appHasLoaded: false,
            freeData:null,
            allDataLoaded:false,
            style: {
                completed: 5,
                root: {
                    backgroundImage: "url(" + backgroundImage + ")",
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    width: '100%',
                    backgroundColor: "#F7DC5A",
                    // height: '100%',
                    backgroundBlendMode:'soft-light',
                    color:'#F7DC5A',
                    flex:1,
                    minHeight:'0'
                },
            }
        }
    }
    fetchData= async()=>{
        await axios.get(rollList)
            .then(res => {
                const {data}=res
                console.log(data)
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    fetchRxData= async()=>{
        await axios.get(userData)
            .then(res => {
                const {data}=res
                this.props.data(data)
                this.setState({
                    allDataLoaded:true
                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    fetchFreeData= async()=>{
        await axios.get(`freePage/get`)
            .then(res => {
                const {data}=res
                this.props.free(data,FREE)
                this.setState({
                    freeData:data
                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    async componentDidMount() {
        this.props.toggleBottomNavbar()
        this.fetchRxData()
        this.fetchData()
        await this.fetchFreeData()
    }
    componentDidUpdate() {
        if (!this.state.allDataLoaded)
            if (this.state.freeData && this.props.UserData.userData!=null){
                this.setState({
                    allDataLoaded:true
                })
            }
    }
    handleDialog=(data)=>{
        this.setState({
            dialogDetail:data.dialog,
            showDialog:true,
        })
    }
    handleDialogAction=(action)=>{
        switch (action) {
            case '#cancel':
                this.setState({
                    showDialog:false,
                })
                break
            default:
                this.setState({
                    showDialog:false,
                })
        }
    }
    render() {
        // const {freeData}=this.state.freeData
        let prizeCodeSection={
            text:'کد جایزه را وارد کن',
            buttonText:'ثبت',
            buttonTextColor:'yellow',
            buttonColor:'rgb(92, 196, 193)',
            firstLayerColor:'brown',
            secondLayerColor:'darkorange',
            thirdLayerColor:' lightorange'
        }
        let topItems=[
            {
                icon:CoinBox,
                text:'گنج روزانه',
                buttonText:'دربافت',
                buttonTextColor:'yellow',
                buttonColor:'rgb(92, 196, 193)',
                firstLayerColor:'lightslategray',
                secondLayerColor:'rgba(255,255,255,0.6)',
                thirdLayerColor:' rgba(255,255,255,0.6)',
                id:'dailyPrize'
            },
            {
                icon:Wheel,
                text:'گردونه شانس',
                buttonText:'جایزه بگیر',
                buttonTextColor:'yellow',
                buttonColor:'rgb(92, 196, 193)',
                firstLayerColor:'lightslategray',
                secondLayerColor:'rgba(255,255,255,0.6)',
                thirdLayerColor:' rgba(255,255,255,0.6)',
                id:'luckSpinner'
            },
        ]
        let ads=[
            {
                blackButtonText:'1000',
                blackButtonIcon:CoinBox,
                blackButtonBackgroundColor:'#000000',
                blackButtonTextColor:'#ffffff',
                title:'هزارتومان جایزه',
                adIcon:CoinBox,
                adText:'میکرومانی',
                text:'با حدس زدن آهنگ ها جایزه مقدی برنده شو و در پیکوپول 1000 تومن جایزه بکیر',
                buttonText:'دانلود میکرومانی',
                buttonBackgroundColor:'blue',
                borderColor:'darkblue',
                adBackgroundColor:'lightblue',
                buttonTextColor:'yellow',
                bottomFontSize:'15px'
            },
            {
                blackButtonText:'1000',
                blackButtonIcon:CoinBox,
                blackButtonBackgroundColor:'#000000',
                blackButtonTextColor:'#ffffff',
                title:'هزارتومان جایزه',
                price:'1000',
                adIcon:CoinBox,
                adText:'QDAY',
                text:'با حدس زدن آهنگ ها جایزه مقدی برنده شو و در پیکوپول 1000 تومن جایزه بکیر',
                buttonText:'دانلود میکرومانی',
                buttonBackgroundColor:'orange',
                borderColor:'red',
                adBackgroundColor:'pink',
                buttonTextColor:'#ffffff',
                bottomFontSize:'15px'
            },

        ]
        let invitation=  {

            topLayerBackgroundColor:'red',
            whiteButtonBackgroundColor:'#ffffff',
            whiteButtonText:'کدمعرف شما: imanhmz',

            introductionButtonText:'دوستات رو معرفی کن',
            introductionButtonColor:'yellow',
            introductionButtonBackgroundColor:'rgb(92, 196, 193)',

            buttonText:'ثبت',
            buttonTextColor:'#fedf33',
            buttonBackgroundColor:'blue',
            borderColor:'darkblue',

            blackButtonText:'1',
            blackButtonIcon:CoinBox,
            blackButtonBackgroundColor:'#000000',
            blackButtonTextColor:'#ffffff',


            buttonColor:'rgb(92, 196, 193)',
            firstLayerColor:'lightslategray',

            text:'دوستت رو معرفی کن و 1سکه طلا بگیر',
            secondLayerColor:'rgba(255,255,255,0.6)',
            thirdLayerColor:' rgba(255,255,255,0.6)'
        }
        let video=  {
            topLayerBackgroundColor:'purple',
            text:'تماشا ویدیو',
            firstLayerColor:'lightslategray',
            icon:Play,
            secondLayerColor:'rgba(255,255,255,0.6)',
            thirdLayerColor:' rgba(255,255,255,0.6)'
        }
        if (this.state.freeData){
            let {freeData}=this.state
            invitation=  {
                topLayerBackgroundColor:'red',
                whiteButtonBackgroundColor:'#ffffff',
                whiteButtonText:freeData.data.ref.refCode,

                introductionButtonText:'دوستات رو معرفی کن',
                introductionButtonColor:'yellow',
                introductionButtonBackgroundColor:'rgb(92, 196, 193)',

                buttonText:'ثبت',
                buttonTextColor:'#fedf33',
                buttonBackgroundColor:'blue',
                borderColor:'darkblue',

                blackButtonText:freeData.data.ref.refCoin,
                blackButtonIcon:freeData.data.ref.refCoin_img=='golen'?goldCoin:silverCoin,
                blackButtonBackgroundColor:'#000000',
                blackButtonTextColor:'#ffffff',


                buttonColor:'rgb(92, 196, 193)',
                firstLayerColor:'lightslategray',

                text:'دوستت رو معرفی کن و 1سکه طلا بگیر',
                secondLayerColor:'rgba(255,255,255,0.6)',
                thirdLayerColor:' rgba(255,255,255,0.6)'
            }
            prizeCodeSection={
                text:'کد جایزه را وارد کن',
                buttonText:'ثبت',
                buttonTextColor:'yellow',
                buttonColor:'rgb(92, 196, 193)',
                firstLayerColor:'brown',
                secondLayerColor:'darkorange',
                thirdLayerColor:' lightorange'
            }
            topItems=[
                {
                    icon:CoinBox,
                    text:'گنج روزانه',
                    buttonText:'دربافت',
                    buttonTextColor:'yellow',
                    buttonColor:'rgb(92, 196, 193)',
                    firstLayerColor:'lightslategray',
                    secondLayerColor:'rgba(255,255,255,0.6)',
                    thirdLayerColor:' rgba(255,255,255,0.6)',
                    id:'dailyPrize'
                },
                {
                    icon:Wheel,
                    text:'گردونه شانس',
                    buttonText:'جایزه بگیر',
                    buttonTextColor:'yellow',
                    buttonColor:'rgb(92, 196, 193)',
                    firstLayerColor:'lightslategray',
                    secondLayerColor:'rgba(255,255,255,0.6)',
                    thirdLayerColor:' rgba(255,255,255,0.6)',
                    id:'luckSpinner'
                },
            ]
            ads=freeData.data.ads_v2.map(data=>{
                    return {
                        blackButtonText:data.prizeVal,
                        blackButtonIcon:data.prizeType,
                        blackButtonBackgroundColor:'#000000',
                        blackButtonTextColor:'#ffffff',
                        title:data.title,
                        adIcon:data.image,
                        adText:data.name,
                        text:data.description,
                        textColor:data.main_text,
                        buttonText:data.btnText,
                        buttonBackgroundColor:data.btn_back,
                        borderColor:data.backColor1,
                        adBackgroundColor:data.backColor2,
                        buttonTextColor:'yellow',
                        bottomFontSize:'15px',
                        actionBtn:data.actionBtn
                    }
                }
            )

            video=  {
                topLayerBackgroundColor:'purple',
                text:'تماشا ویدیو',
                firstLayerColor:'lightslategray',
                icon:Play,
                secondLayerColor:'rgba(255,255,255,0.6)',
                thirdLayerColor:' rgba(255,255,255,0.6)'
            }
        }
        const {dialogDetail}=this.state
        const customDialog={
            button:{
                text:'',
                backgroundColor:'transparent',
                bottomFontSize:'15px',
                buttonTextColor:'red',
                borderColor:'transparent'
            },
            data:{
                dialog:dialogDetail,
            }
        }
        const handleClose=(()=>{
            this.setState({
                showDialog:false
            })
        })
        return(
            <Grid direction={"column"} item container style={this.state.style.root}>
                <Dialog
                    // disableBackdropClick
                    open={this.state.showDialog}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{background:'transparent !important'}}
                    PaperProps={{
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                        },
                    }}
                >
                    <DialogContent>
                        <CustomDialog action={this.handleDialogAction} data={customDialog}/>
                    </DialogContent>
                </Dialog>
                {
                    this.state.allDataLoaded &&
                    <Grid item sm={12} xs={12} direction={"column"} justify={'center'} container style={{flex:'1',minHeight:'0'}}>
                        <Grid item container>
                            <Toolbar type='sideToolbar'/>
                        </Grid>
                        {
                            this.state.freeData &&
                            <Grid item container xs={12} justify={"center"} sm={12} className='scrollBar' style={{flex:'1',minHeight:'0',overflow:'auto'}}>
                                {/*<Grid item container sm={11} xs={11} style={{margin:'20px 0'}} >*/}
                                {/*    <Video data={video}/>*/}
                                {/*</Grid>*/}
                                <Grid justify={"space-around"} item container xs={12}  sm={12} >
                                    <Grid justify={"space-around"} item container xs={12}  sm={12} >
                                        {
                                            topItems.map(data=>{
                                                return( <Grid item sm={5} xs={5} style={{position:'relative'}} >
                                                    <ItemHolder data={data}/>
                                                </Grid>)
                                            })
                                        }
                                    </Grid>
                                </Grid>
                                <Grid item container sm={11} xs={11} style={{margin:'15px 0'}} >
                                    <Invitation callBack={this.handleDialog} data={invitation}/>
                                </Grid>
                                <Grid item container sm={11} xs={11} style={{margin:'15px 0'}} >
                                    <PrizeCode callBack={this.handleDialog} data={prizeCodeSection}/>
                                </Grid>
                                <Grid justify={"center"} alignItems={"center"} item container sm={11} xs={11}>
                                    {
                                        ads.map(data=>{
                                            return(<Grid sm={12}  xs={12} style={{margin:'15px 0'}} container item>
                                                <Ad data={data}/>
                                            </Grid>)
                                        })
                                    }
                                </Grid>
                                <Grid justify={"center"} alignItems={"center"} item sm={12} xs={12} container>
                                    <Grid justify={"center"} alignItems={"center"} item sm={12} xs={12} container>
                                        <p style={{color:'#000000',textAlign:'center'}}>
                                            {this.state.freeData.data.socialMedaia.txtSocial}
                                        </p>
                                    </Grid>
                                    <Grid item sm={10} xs={10} justify={"center"} container>
                                        <Grid item sm={2} xs={2} style={{padding:'5px'}} className={'clickable'} container onClick={()=>{
                                            window.location=this.state.freeData.data.socialMedaia.instagram
                                        }
                                        }>
                                            <img src={instagram} alt=""/>
                                        </Grid>
                                        <Grid item sm={2} xs={2} style={{padding:'5px'}} className={'clickable'} container onClick={()=>{
                                            window.location=this.state.freeData.data.socialMedaia.telegram
                                        }}>
                                            <img src={telegram} alt=""/>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        }

                    </Grid>
                }
                {
                    !this.state.allDataLoaded &&
                    <Grid m={2} xs={2} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                          style={{position:'relative',
                              top:'50%',left:'50%',transform:'translate(-50%,-50%)'}}
                    >
                        <Grid item container justify={"center"} style={{position:'absolute',
                        }}>
                            <PicoLoader/>
                        </Grid>
                    </Grid>
                }
            </Grid>
        )
    }
}
const mapStateToProps=state=>({
    UserData:state.UserData,
    Free:state.Free
})
export default connect(mapStateToProps,{data,free})(FreePage)